// Others
import axiosClient from './axiosClient';
import { IBodyChangePassword, IProfile, IQueryParamUser, IUser, IUserDetail } from '~/utils/interface/user';
import { urlApiUser } from '~/utils/constants/apis';
import { IBodyUpdate } from '~/utils/interface/common';
import { IBaseResponse, IListDataResponse } from '~/utils/interface/base';
import { CONTENT_TYPE_FORM_DATA } from '~/utils/constants/common';

const userApi = {
  getListUser: (params: IQueryParamUser) => {
    const url = urlApiUser.getListUser;
    return axiosClient.get<IBaseResponse<IListDataResponse<IUser[]>>>(url, { params });
  },

  getDetailUser: (id: string) => {
    const url = urlApiUser.getDetailUser(id);
    return axiosClient.get<IBaseResponse<IUserDetail>>(url);
  },

  deleteUser: (id: string) => {
    const url = urlApiUser.deleteUser(id);
    return axiosClient.delete<IBaseResponse>(url);
  },

  createUser: (formData: FormData) => {
    const url = urlApiUser.createUser;
    return axiosClient.post<IBaseResponse>(url, formData, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  updateUser: (params: IBodyUpdate<FormData>) => {
    const { id, body } = params;
    const url = urlApiUser.updateUser(id);
    return axiosClient.put<IBaseResponse>(url, body, {
      headers: { 'Content-Type': CONTENT_TYPE_FORM_DATA },
    });
  },

  changePasswordUser(body: IBodyChangePassword) {
    const url = urlApiUser.changePasswordUser;
    return axiosClient.put<IBaseResponse>(url, body);
  },

  getProfile() {
    const url = urlApiUser.getProfile;
    return axiosClient.get<IBaseResponse<IProfile>>(url);
  },
};

export default userApi;
